import { RESIZE_CANVAS } from '../../action-types/ui/canvas';

export const resizeCanvas = (width, height) => ({
  type: RESIZE_CANVAS,
  width,
  height,
});



// WEBPACK FOOTER //
// ./src/redux/actions/ui/canvas.js